import { render, staticRenderFns } from "./AppSuggestions.vue?vue&type=template&id=c1bc6c12&scoped=true&"
import script from "./AppSuggestions.vue?vue&type=script&lang=js&"
export * from "./AppSuggestions.vue?vue&type=script&lang=js&"
import style0 from "./AppSuggestions.vue?vue&type=style&index=0&id=c1bc6c12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1bc6c12",
  null
  
)

export default component.exports